module.exports = __webpack_public_path__ + "static/media/confetti.bad5caed.svg";